<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="text-uppercase mb-0">Dashboard</h4>
        </div>
        <div>
          <Datepicker v-model="selectedDate" dark auto-apply format="dd MMM yyyy" :max-date="new Date()" />
        </div>
      </div>
      <div class="col-lg-12 mt-3" v-if="displayProfiles">
        <div class="row justify-content-between wd-100" v-if="!isCommanderLogin && profileTypes.length > 0">
          <div v-for="(profileType, index) in profileTypes" :key="index" class="col" style="max-width: 50%;"
            :class="{ 'no-right-pad': index < profileTypes.length - 1 == true }">
            <top-candidates-details-card :img-path="`/img/${profileType.dna_profile_name}.jpg`"
              :img-text="profileType.dna_profile_name" :dna-profile-id="profileType.dna_profile_id"
              :selected-date="selectedDate" />
          </div>
        </div>
        <div v-if="isCommanderLogin && profileTypes.length > 0" class="row justify-content-between wd-100"
          style="padding-left: 1rem;padding-right: 1rem;">
          <TopWellnessCandidates :img-path="imagePath" :img-text="`Wellness`"
            :dna-profile-id="selectedProfileTypeId" :selected-date="selectedDate" :icon-class="iconClass"/>
        </div>
      </div>
      <div class="col-lg-25 mt-3" v-else-if="profileTypes.length > 0">
        <top-candidates-details-card :img-path="''"
              :img-text="'N/A'" :dna-profile-id="profileTypes[0].dna_profile_id"
              :selected-date="selectedDate" />
      </div>

      <div class="col-lg-12 mt-3">
        <div class="row trends-section" v-if="trendingUserData && trendingUserData.length > 0">
          <div v-for="alertType in trendingUserData" :key="alertType.alert_id"
            class="col-xxl-4 col-md-6 col-12 mb-xxl-0 mb-1 text-capitalize w-25 p-1">
            <trends-card :header-content="alertType.alert_name" :type="alertType.type" :users="alertType.users"
              :selected-date="selectedDate" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <section-chart id="chart" header="Sleep, recovery and strain ranges: All sections" height="480"
              :title="selectedDate" :alerts="alerts" :chart="chart" :filter-applied="filterApplied"
              :filter-key="filteredKey" />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <performance-table id="performanceTable" :title="performanceTableTitle" :data="performanceData"
          :selected-date="selectedDate" @selected-page="(selectedValue) => (page = selectedValue)"
          :selected-section-id="selectedSection" @selected-section-id="
            (selectedValue) => (selectedSection = selectedValue)"
          :selected-platoon-id="selectedPlatoon" @selected-platoon-id="
            (selectedValue) => (selectedPlatoon = selectedValue)"
          @selected-sort="(selectedValue) => (sort = selectedValue)"
          @selected-order="(selectedValue) => (order = selectedValue)" />
      </div>
    </div>
  </div>
</template>
<script>
import Constants from "@/helpers/constants";
import ChartUtils from "@/helpers/chartUtils";
import Utils from "@/helpers/utils";
import TopCandidatesDetailsCard from "./components/TopCandidateDetailsCard.vue";
import TopWellnessCandidates from "./components/TopWellnessCandidates.vue";
import SectionChart from "./components/SectionChart.vue";
import PerformanceTable from "./components/PerformanceTable.vue";
import TrendsCard from "./components/TrendsCard.vue"
import Datepicker from "@vuepic/vue-datepicker";
import dayjs from "dayjs";
import styles from "./Default.vue?vue&type=style&index=0&lang=scss&module=1";

export default {
  name: "DashboardDefault",
  components: {
    Datepicker,
    SectionChart,
    PerformanceTable,
    TrendsCard,
    TopCandidatesDetailsCard,
    TopWellnessCandidates,
  },
  data() {
    return {
      page: Constants.DEFAULT_PAGE,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      sort: "name",
      order: "asc",
      selectedSection: Constants.DEFAULT_SECTION,
      selectedPlatoon: Constants.DEFAULT_PLATOON,
      selectedDate: dayjs(),
      alerts: [],
      scoreRanges: [],
      performanceData: [],
      performanceApiResponse: [],
      trendsData: {
        lowestSleep: [],
        lowestRecovery: [],
        highestStrain: [],
        lowestStrain: []
      },
      chart: {
        labels: [],
        datasets: [],
      },
      workoutTypes: [],
      profileTypes: [],
      trendingUserData: [],
      abnormalAlerts: [],
      performanceTableTitle: 'Performance',
      filterApplied: false,
      filteredKey: '',
      isCommanderLogin: false,
      selectedProfileTypeId: 'a3452f94738cbeefe8c79c79f7336522',
      userTrendsData: null,
      imagePath: `/img/adcda_logo.png`,
      iconClass: `client-icon`,
      displayProfiles: Constants.DISPLAY_PROFILE_TYPES,
    };
  },
  watch: {
    selectedDate() {
      if (this.selectedDate instanceof Date) {
        this.selectedSection = Constants.DEFAULT_SECTION;
        this.page = 1;
        this.getScoreRanges();
        this.getUserPerformanceTrends();
      } else this.selectedDate = new Date();
    },
    selectedSection() {
      this.getPerformanceData('', false);
    },
    selectedPlatoon() {
      this.getPerformanceData('', false);
    },
    page() {
      this.getPerformanceData('', false);
    },
    sort() {
      this.getPerformanceData('', false);
    },
    order() {
      this.getPerformanceData('', false);
    },
  },
  mounted() {
    let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
    //console.log('log in userdata', loggedInUser)
    if (loggedInUser.role && loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
      this.isCommanderLogin = true;
    }
    if(loggedInUser.user_id == Constants.CMNDRS.CDACMNDR || loggedInUser.user_id == Constants.CMNDRS.CDAADMIN) {
      this.imagePath = `/img/cda_department_logo.png`;
      this.iconClass = `client-icon size-icon`;
    }
    
    this.getWorkoutTypes();
    this.getProfileTypes();
    this.getScoreRanges();
    this.getUserPerformanceTrends();
  },
  methods: {
    getScoreRanges() {
      this.$store
        .dispatch("data/scoreRanges", {
          dt_from: dayjs(this.selectedDate)
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((data) => {
          this.scoreRanges = data.data;
          this.setAlerts(this.scoreRanges);
          this.updateChartData();
          this.getPerformanceData('', true);
        });
    },
    setAlerts(scoreRanges) {
      this.alerts = [];
      // Set trends

      // Set warnings based on score ranges
      // Check strain
      scoreRanges.map((range) => {
        if (range.max_strain < Constants.STRAIN_LOW) {
          this.addAlert(
            "strain",
            range.section_name,
            `Strain is low (${range.min_strain} - ${range.max_strain}). Increase strain to gain fitness.`,
            false
          );
        }

        if (range.max_recovery_score <= Constants.RECOVERY_WARNING) {
          this.addAlert(
            "recovery",
            range.section_name,
            `Everyone's recovery is low (${range.min_recovery_score} - ${range.max_recovery_score}). Try to spend extra time on recovery activities today.`,
            true
          );
        } else if (range.min_recovery_score <= Constants.RECOVERY_DANGER) {
          this.addAlert(
            "recovery",
            range.section_name,
            `At least one user's recovery is low. Try to keep to recovery activities.`,
            true
          );
        } else if (range.max_recovery_score - range.min_recovery_score > 50) {
          this.addAlert(
            "recovery",
            range.section_name,
            `Recovery range is wide (${range.min_recovery_score} - ${range.max_recovery_score}). Some users may not be well recovered for the day.`,
            true
          );
        }

        if (range.max_sleep_score <= Constants.SLEEP_WARNING) {
          this.addAlert(
            "sleep",
            range.section_name,
            `Sleep score is low (${range.min_sleep_score} - ${range.max_sleep_score}). Aim for consistent bed and wake times.`,
            true
          );
        }

        if (
          range.min_recovery_score > Constants.RECOVERY_WARNING &&
          range.min_sleep_score > Constants.SLEEP_WARNING &&
          range.min_strain > Constants.STRAIN_LOW
        ) {
          this.addAlert(
            "general",
            range.section_name,
            "Sleep, recovery and strain are well balanced. Keep this up to gain fitness and improve wellness.",
            false
          );
        } else if (
          range.min_recovery_score > Constants.RECOVERY_WARNING &&
          range.min_sleep_score > Constants.SLEEP_WARNING
        ) {
          this.addAlert(
            "recovery",
            range.section_name,
            "Everyone is well recovered and ready for the day. Aim for higher strain activities to gain fitness.",
            false
          );
        }
      });

      if (scoreRanges.length > 0 && this.alerts.length == 0) {
        this.addAlert(
          "general",
          "No abnormalies detected",
          "Sleep, recovery and strain are in range.",
          false
        );
      }
    },
    addAlert(color, title, body, show_warning_icon = false) {
      this.alerts.push({
        color: color,
        title: title,
        body: body,
        warning: show_warning_icon,
        key: title + color,
      });
    },
    getPerformanceData(alertType, prepareTrends) {
      this.$store
        .dispatch("data/performanceByPlatoonAndSection", {
          page: this.page,
          page_size: this.pageSize,
          sort: this.sort,
          order: this.order,
          section_id: this.selectedSection || -1,
          platoon_id: this.selectedPlatoon || -1,
          dt_from: dayjs(this.selectedDate)
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((data) => {
          this.performanceData = data.data;
          if (this.performanceApiResponse.length == 0 && data.data.count > 0
            || !alertType) {
            this.performanceApiResponse = data.data;
          }
          if (!!alertType == true && Constants.SECTIONS.includes(alertType.toUpperCase())) {
            this.selectedSection = Constants.SECTIONS.indexOf(alertType.toUpperCase());
          } else if (!!alertType == true) {
            this.performanceApiResponse = data.data;
            this.applyAlertFilterOnPerformanceData(alertType);
          }

          if (prepareTrends) {
            this.getAbnormalAlerts();
          }
        });
    },
    extractAndPrepareTrends() {
      if (this.userTrendsData) {
        this.trendingUserData = [];
        this.trendingUserData.push(this.prepareTrendsData(1, "High_Strain", "Highest Strain", "#c2b7c2", this.userTrendsData.highStrainUsers, "strain"));
        this.trendingUserData.push(this.prepareTrendsData(2, "Low_Strain", "Lowest Strain", "#c2b7c2", this.userTrendsData.lowStrainUsers, "strain"));
        this.trendingUserData.push(this.prepareTrendsData(3, "Low_Sleep", "Lowest Sleep Scores", "#dfedf0", this.userTrendsData.lowSleepUsers, "sleep_score"));
        this.trendingUserData.push(this.prepareTrendsData(4, "Low_Recovery", "Lowest Recovery Scores", "#72b3a8", this.userTrendsData.lowRecoveryUsers, "recovery_score"));
      }
    },
    prepareTrendsData(alertId, trendType, alertName, color, performanceData, scoreParameter) {
      let alertTrendDetails = {
        alert_id: alertId,
        alert_name: alertName,
        bg_color: color,
        type: trendType,
        users: []
      }
      let alertUsers = [];
      for (let lowSleepTrend of performanceData) {
        let lowSleepUserDetails = {
          udid: lowSleepTrend.user[0].udid,
          name: lowSleepTrend.user[0].name,
          platoon_name: lowSleepTrend.user[0].platoon_name,
          section_name: lowSleepTrend.user[0].section_name,
          team: lowSleepTrend.user[0].platoon_name + '/' + lowSleepTrend.user[0].section_name,
          score: lowSleepTrend[scoreParameter]
        }
        alertUsers.push(lowSleepUserDetails);
      }
      alertTrendDetails.users = alertUsers;
      return alertTrendDetails;
    },
    getProfileTypes() {
      this.$store
        .dispatch("list/getProfileList", {
          sort: "dna_profile_name",
          order: "asc",
          is_active: 1,
          is_top: 1,
        })
        .then(({ data }) => {
          if (data && data.length > 0) {
            this.profileTypes = data;
          }
        });
    },
    getWorkoutTypes() {
      this.$store
        .dispatch("list/getWorkoutTypes", {
          sort: "workout_type_id",
          order: "asc",
          is_active: -1,
        })
        .then(({ data }) => {
          if (data && data.length > 0) {
            this.workoutTypes = data;
          }
        });
    },
    updateChartData() {
      let colorCodes = {
        sleep: styles.colorSleep,
        recovery: styles.colorRecovery,
        strain: styles.colorStrain,
      };
      this.chart = Object.assign(
        {},
        ChartUtils.scoreRangesChart(this.scoreRanges, colorCodes)
      );
    },
    setAbnormalAlerts(abnormalAlertsData) {
      let filteredData = [];
      //this.alerts = [];
      this.findAlertIndexAndDelete(this.alerts.findIndex(element => element.title === 'RHR'));
      this.findAlertIndexAndDelete(this.alerts.findIndex(element => element.title === 'HRV'));
      this.findAlertIndexAndDelete(this.alerts.findIndex(element => element.title === 'SPO'));
      if (!!abnormalAlertsData == true) {
        if (abnormalAlertsData.rhrAlerts.length > 0) {
          let rhrUdids = this.abnormalAlerts.rhrAlerts.map(a => a.udid);
          filteredData = this.performanceData.rows.filter((element) => { return rhrUdids.includes(element.udid); });
          if (filteredData.length > 0) {
            let rhrAlertDesc = '';
            if (filteredData.length == 1) {
              rhrAlertDesc = `A user has a resting heart rate that deviates from his/her weekly baseline.`;
            } else {
              rhrAlertDesc = `${filteredData.length} people have resting heart rate that deviates from their weekly baseline.`;
            }
            this.addAlert("recovery", "RHR", rhrAlertDesc, true);
          }
          filteredData = [];
        }

        if (abnormalAlertsData.spoAlerts.length > 0) {
          let spoUdids = this.abnormalAlerts.spoAlerts.map(a => a.udid);
          filteredData = this.performanceData.rows.filter((element) => { return spoUdids.includes(element.udid); });
          if (filteredData.length > 0) {
            let spoAlertDesc = '';
            if (filteredData.length == 1) {
              spoAlertDesc = `A user has a SpO2 reading that deviates from his/her weekly baseline.`;
            } else {
              spoAlertDesc = `${filteredData.length} people have SpO2 reading that deviates from their weekly baseline.`;
            }
            this.addAlert("recovery", "SPO", spoAlertDesc, true);
          }
        }

        if (abnormalAlertsData.hrvAlerts.length > 0) {
          let hrvUdids = this.abnormalAlerts.hrvAlerts.map(a => a.udid);
          filteredData = this.performanceData.rows.filter((element) => { return hrvUdids.includes(element.udid); });
          if (filteredData.length > 0) {
            let hrvAlertDesc = '';
            if (filteredData.length == 1) {
              hrvAlertDesc = `A user has a HRV value that deviates from his/her weekly baseline.`;
            } else {
              hrvAlertDesc = `${filteredData.length} people have HRV value that deviates from their weekly baseline.`;
            }
            this.addAlert("sleep", "HRV", hrvAlertDesc, true);
          }
        }
        //sort alerts
        this.alerts.sort((b, a) => a.warning - b.warning);
      }
    },
    findAlertIndexAndDelete(index) {
      if (index !== -1) {
        this.alerts.splice(index, 1);
      }
    },
    getAbnormalAlerts() {
      let dtFrom = dayjs(this.selectedDate).subtract(180, 'days').utc().endOf("day").format(Constants.BUCKET_FORMAT);
      let dtTo = dayjs(this.selectedDate).utc().startOf("day").format(Constants.BUCKET_FORMAT);
      this.$store
        .dispatch("data/abnormalAlerts", {
          dt_from: dtFrom,
          dt_to: dtTo,
        })
        .then((response) => {
          this.abnormalAlerts = null;
          this.abnormalAlerts = response.data;
          if (!!response == true) {
            this.setAbnormalAlerts(response.data);
          }
        });
    },
    filterTheTableByAlert(alertType, alertKey) {
      if (alertType) {
        this.filterApplied = true;
        this.filteredKey = alertKey;
        this.performanceTableTitle = Utils.camelizeString(alertKey, '-') + ": Atypical range";
        this.getPerformanceData(alertType, false);
        //this.applyAlertFilterOnPerformanceData(alertType);
      } else {
        this.resetFilter();
      }
    },
    applyAlertFilterOnPerformanceData(alertType) {
      let filteredData = [];
      if (alertType == Constants.ALERT_HRV) {
        let hrvUdids = this.abnormalAlerts.hrvAlerts.map(a => a.udid);
        filteredData = this.performanceApiResponse.rows.filter((element) => { return hrvUdids.includes(element.udid); });
      } else if (alertType == Constants.ALERT_SPO) {
        let spoUdids = this.abnormalAlerts.spoAlerts.map(a => a.udid);
        filteredData = this.performanceApiResponse.rows.filter((element) => { return spoUdids.includes(element.udid); });
      } else if (alertType == Constants.ALERT_RHR) {
        let rhrUdids = this.abnormalAlerts.rhrAlerts.map(a => a.udid);
        filteredData = this.performanceApiResponse.rows.filter((element) => { return rhrUdids.includes(element.udid); });
      }

      if (filteredData.length > 0) {
        this.performanceData.rows = filteredData;
        this.performanceData.count = filteredData.length;
      }
    },
    resetFilter() {
      this.filterApplied = false;
      this.filteredKey = '';
      this.performanceTableTitle = 'Performance';
      this.selectedSection = -1;
      this.getPerformanceData('', false);
    },
    getUserPerformanceTrends() {
      this.$store
        .dispatch("data/userPerformanceTrends", {
          dt_from: dayjs(this.selectedDate)
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.selectedDate)
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
        })
        .then((data) => {
          //console.log("userPerformanceTrends Data: ", data);
          this.userTrendsData = data.data;
          this.extractAndPrepareTrends()
        });
    },
  },
};
</script>

<style lang="scss" scoped>
:export {
  colorSleep: $color-sleep;
  colorRecovery: $color-recovery;
  colorStrain: $color-strain;
}

.trends-section {
  margin-top: 0.3rem !important;
  margin-bottom: 0.3rem !important;
  margin-left: 0.001rem !important;
  margin-right: 0.001rem !important;
}

.no-right-pad {
  padding-right: 0;
}

.no-left-pad {
  padding-right: 0;
}
</style>
